import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { PATH_LOGIN } from 'routing/path'
import { useRequestPasswordResetMutation } from 'actions/client/client-account-api';
import { translationApi  } from 'actions/translation-api';
import { showSuccessNotification, showErrorNotification } from "actions/action-complete-notificator";

const RequestPasswordReset = () => {
	const navigate = useNavigate();

	const [ requestPasswordReset, { isLoading: requestPasswordResetInProgress }] = useRequestPasswordResetMutation();
	const translations = useSelector(translationApi.endpoints.getTranslations.select()).data ?? {};

	const submitDisabled = requestPasswordResetInProgress;
  const handleSubmit = async (fields) => {
    const resetPasswordRequest = {
      email: fields?.email
    };

    const result = await requestPasswordReset(resetPasswordRequest);
    if ('error' in result) {
      showErrorNotification(result.error);
    }
    else {
      showSuccessNotification("Wysłano wiadomość na adres " + resetPasswordRequest.email);
      navigate(PATH_LOGIN);
    }
  };
  
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email(translations.warningValueInvalid)
      .required(translations.warningFieldRequired)
  });

  const initialValues = {
    email: ""
  };

  const randomAutoComplete = Math.random().toString(36).replace(/[^a-z]+/g, "").substring(0, 5);
  return (
    <main>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <div className="container">
            <div className="row justify-content-center form-bg-image">
              <div className="col-12 d-flex align-items-center justify-content-center">
                <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                  <div className="text-center text-md-center mb-4 mt-md-0">
                    <h1 className="mb-0 h3">Zmiana hasła</h1>
                  </div>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={ async (fields) => { await handleSubmit(fields) }}>
                    { ({ errors, touched }) => (
                      <Form autoComplete={randomAutoComplete}>
                        <div className="form-group mb-4">
                          <label htmlFor="email">{translations.email}</label>
                          <Field id="email" name="email" type="text" className={`form-control ${errors.email && touched.email ? "is-invalid" : ""}`} />
                          <ErrorMessage name="email" component="div" className="invalid-feedback" />
                        </div>
                        <div className="d-grid">
                          <button id="saveButton" type="submit" className="btn btn-dark" disabled={submitDisabled ? 'disabled' : null}>Wyślij email</button>
                        </div>
                      </Form>
                    )}
                  </Formik>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}

export default RequestPasswordReset;
